import { runAsyncPipe, } from './asyncPipe';
import { tap } from './functional-utils';
import { catchType, catcher, createPipeReturn, createPipeThrow, } from './syncPipe';
export function asyncFlow(...steps) {
    return (initialValue) => {
        return runAsyncPipe([], initialValue, ...steps);
    };
}
asyncFlow.catch = catcher;
asyncFlow.catchType = catchType;
asyncFlow.return = createPipeReturn;
asyncFlow.throw = createPipeThrow;
asyncFlow.debug = (label = '') => tap((value) => console.log(label, value));
asyncFlow.inputExtends = () => {
    const step = (value) => value;
    return Object.assign(step, { _inputExtends: undefined });
};
asyncFlow.inputType =
    () => (value) => value;
//# sourceMappingURL=asyncFlow.js.map